module.exports = __webpack_public_path__ + "media/images/noofferfound-10e80d84.gif";